import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const NAV_BTN = "p-1.5 rounded-md border border-[#E5E7EB] text-[#4D4D4D] hover:border-[#156F5B] hover:text-[#156F5B]";
const PRESET_TRANSITION = { transition: "background-color .2s ease, color .2s ease" };

export function FaultsToolbar({
  presets, preset, label, onPrev, onNext, onPreset,
  sites, site, onSite, rules, rule, onRule, costOnly, onCostOnly,
}) {
  return (
    <div className="mt-6 k-card p-4 flex items-center justify-between flex-wrap gap-4">
      <div className="flex items-center gap-2 flex-wrap">
        <button onClick={onPrev} data-testid="faults-prev-btn" className={NAV_BTN}>
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="text-sm font-heading font-semibold text-[#212121] min-w-[190px] text-center" data-testid="faults-range-label">
          {label}
        </span>
        <button onClick={onNext} data-testid="faults-next-btn" className={NAV_BTN}>
          <ChevronRight className="h-4 w-4" />
        </button>
        <div className="flex rounded-md border border-[#E5E7EB] overflow-hidden ml-1">
          {presets.map((p) => (
            <button
              key={p.label}
              onClick={() => onPreset(p)}
              data-testid={`faults-preset-${p.days}-${p.mode}`}
              className={`px-3 py-1.5 text-xs font-heading font-semibold ${
                preset.label === p.label ? "bg-[#156F5B] text-white" : "bg-white text-[#4D4D4D] hover:bg-[#F3F8F7]"
              }`}
              style={PRESET_TRANSITION}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <select value={site} onChange={(e) => onSite(e.target.value)} data-testid="faults-site-filter" className="k-input !py-1.5 !w-auto text-xs">
          <option value="">All sites</option>
          {sites.map((s) => (
            <option key={s.id} value={s.id}>{s.dis}</option>
          ))}
        </select>
        <select value={rule} onChange={(e) => onRule(e.target.value)} data-testid="faults-rule-filter" className="k-input !py-1.5 !w-auto text-xs max-w-[240px]">
          <option value="">All rules</option>
          {rules.map((r) => (
            <option key={r.rule_id} value={r.rule_id}>{r.rule}</option>
          ))}
        </select>
        <label className="flex items-center gap-1.5 text-xs text-[#4D4D4D] cursor-pointer">
          <input type="checkbox" checked={costOnly} onChange={(e) => onCostOnly(e.target.checked)} data-testid="faults-cost-only-toggle" />
          With cost only
        </label>
      </div>
    </div>
  );
}
